webpackJsonp([1],{

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c9dadd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(681);
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c9dadd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RcvV2__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styles_scss__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_styles_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    "RcvV2": __WEBPACK_IMPORTED_MODULE_0__RcvV2__["a" /* default */]
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_core__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_renderers__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_charts__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PracticeRcvv2_InstructionComponentV2_vue__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PracticeRcvv2_FooterButtonComponent_vue__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PracticeRcvv2_Rcv2StartPage_vue__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PracticeRcvv2_CandidateIconComponentV2_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_assets_rcv_images_pigion_png__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_assets_rcv_images_pigion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_assets_rcv_images_pigion_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_css__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts_components__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_app_config__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_echarts__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts__ = __webpack_require__(678);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















Object(__WEBPACK_IMPORTED_MODULE_3_echarts_core__["c" /* use */])([__WEBPACK_IMPORTED_MODULE_4_echarts_renderers__["a" /* CanvasRenderer */], __WEBPACK_IMPORTED_MODULE_5_echarts_charts__["a" /* BarChart */], __WEBPACK_IMPORTED_MODULE_14_echarts_components__["b" /* TitleComponent */], __WEBPACK_IMPORTED_MODULE_14_echarts_components__["c" /* TooltipComponent */], __WEBPACK_IMPORTED_MODULE_14_echarts_components__["a" /* LegendComponent */]]);

var appData = Object(__WEBPACK_IMPORTED_MODULE_15__config_app_config__["a" /* getAppConfig */])();
var ballotWinnerTimer = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Rcv",
  inject: ["rcvV2PageId"],
  data: function data() {
    return {
      winnerImageUrl: __WEBPACK_IMPORTED_MODULE_10__public_assets_rcv_images_pigion_png___default.a,
      direction: null,
      count: 0,
      final: null,
      updatedOption: [],
      disablestart: false,
      styleProps: null,
      heading: "",
      description: "",
      stepHeadingText: "",
      ofText: "",
      instructionSet: null,
      rowHeader: null,
      winnerText: "",
      label: "",
      roundValue: null,
      loader: true,
      chartOptions: null,
      iconColor: [],
      iconName: [],
      footerButtonState: "initial",
      showHowVotesAreCounted: false,
      showStartPage: true,
      showBackButton: false,
      exitButtonLink: null,
      buttonLabel: null,
      // Add winnerDivStyle computed property for styling the custom winner div
      winnerDivStyle: {
        position: "absolute",
        left: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["i" /* isSmallScreen */] ? "0%" : "0%",
        top: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["i" /* isSmallScreen */] || __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["h" /* isMediumScreen */] ? "0%" : "0%",
        fontFamily: "Whyte, sans-serif",
        lineHeight: "42px",
        color: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["b" /* customColors */][1],
        fontWeight: 800,
        fontSize: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["i" /* isSmallScreen */] || __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["h" /* isMediumScreen */] ? "26px" : "36px",
        zIndex: 10 // Make sure it appears above the chart
      },
      currentVotes: [],
      isNext: null,
      stepCount: null,
      startPageAltText: null
    };
  },

  components: {
    "v-instructions": __WEBPACK_IMPORTED_MODULE_6__components_PracticeRcvv2_InstructionComponentV2_vue__["a" /* default */],
    "v-icon": __WEBPACK_IMPORTED_MODULE_9__components_PracticeRcvv2_CandidateIconComponentV2_vue__["a" /* default */],
    "v-footer-button": __WEBPACK_IMPORTED_MODULE_7__components_PracticeRcvv2_FooterButtonComponent_vue__["a" /* default */],
    "v-start-page": __WEBPACK_IMPORTED_MODULE_8__components_PracticeRcvv2_Rcv2StartPage_vue__["a" /* default */],
    VChart: __WEBPACK_IMPORTED_MODULE_16_vue_echarts__["a" /* default */]
  },
  watch: {
    showHowVotesAreCounted: function showHowVotesAreCounted(newVal) {
      var _this = this;

      if (newVal && this.count === 1) {
        this.$nextTick(function () {
          _this.graphInitor();
        });
      }
    },

    count: function count(newCount, oldCount) {
      this.initUpdateOption();
    }
  },
  methods: {
    backToStartPage: function backToStartPage() {
      this.count = 0;
      this.showStartPage = true;
      this.showHowVotesAreCounted = false;
      this.showBackButton = false;
    },

    startClicked: function startClicked() {
      this.count = 1;
      this.showBackButton = true;
      this.showStartPage = false;
      this.showHowVotesAreCounted = true;

      // Add these lines
      var round0 = Object(__WEBPACK_IMPORTED_MODULE_15__config_app_config__["b" /* getInitialRoundObj */])();
      this.updatedOption = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round0, { hasVotingEnded: false });

      // Set initial vote values
      if (round0 && round0[0] && round0[0].data) {
        this.currentVotes = round0[0].data.slice(1).map(function (dataObj) {
          return dataObj.value || 0;
        });
      }

      this.initUpdateOption();
      this.graphInitor(); // Add this line to initialize the chart
    },
    //On clicking previous ,previous logic is handling here
    onprevious: function onprevious() {
      this.isNext = false;
      this.goTo();

      this.disablestart = false;
      this.count = this.count - 1;
      this.direction = "prev";
      if (this.count < 1) {
        this.count = 1;
      }

      // Get the current series data before updating the graph
      var updatedOption = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(appData));
      var currentRound = updatedOption[this.count - 1] || { data: [] };
      // Skip the first value by starting from index 1
      this.currentVotes = currentRound.data.slice(1).map(function (dataObj) {
        return dataObj.value || 0;
      });

      //initing the graph with updated changes
      this.initUpdateOption();
    },

    //used to initing the graph with latest option
    initUpdateOption: function initUpdateOption() {
      var _this2 = this;

      var updatedOption = void 0;
      var eliminatedOpacity = 0.2;
      var afterEliminationOpacity = 0.05;

      updatedOption = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(appData)).map(function (round) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round, {
          data: round.data.map(function (dataObj, index) {
            if (index == 4) {
              if (_this2.count === 3) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this2.count === 2) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 3) {
              if (_this2.count === 4) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this2.count === 3) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 6) {
              if (_this2.count === 5) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this2.count === 4) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 2) {
              if (_this2.count === 6) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this2.count === 5) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            return dataObj;
          })
        });
      });

      if (this.count == 6) {
        ballotWinnerTimer = setTimeout(function () {
          _this2.final = true;
          updatedOption = appData.map(function (round) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round, {
              data: round.data.map(function (dataObj, index) {
                if (index === 1) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    color: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["b" /* customColors */][1]
                  });
                }
                if (index === 2) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 3) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 4) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 5) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    color: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["b" /* customColors */][5]
                  });
                }
                if (index === 6) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                return dataObj;
              })
            });
          });
          _this2.disablestart = false;
          _this2.updateGraph(updatedOption);
        }, 1500);
      }
      if (this.count === 5 && this.direction === "prev") {
        this.final = false;
        updatedOption = appData.map(function (round, index) {
          round.data[1] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round.data[1], {
            itemStyle: {
              color: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["k" /* stepFivePurpleColors */][index]
            }
          });
          round.data[5] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round.data[5], {
            itemStyle: {
              color: __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["j" /* stepFiveOrangeColors */][index]
            }
          });
          return round;
        });
      }
      updatedOption = appData.map(function (round, roundIndex) {
        if (roundIndex > _this2.count) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round, {
            data: round.data.map(function (dataObj) {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dataObj, {
                value: 0
              });
            })
          });
        }
        return round;
      });

      this.updateGraph(updatedOption);
    },

    //on clicking the next, next logic is handlling here
    onnext: function onnext(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.isNext = true;
      this.goTo();
      this.direction = "next";
      this.final = false;

      var vm = this;
      this.count = this.count + 1;
      if (this.count > 5) {
        this.count = 6;
        this.disablestart = true;
      }
      // Get the current series data before updating the graph
      var updatedOption = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(appData));
      var currentRound = updatedOption[this.count - 1] || { data: [] };
      // Skip the first value by starting from index 1
      this.currentVotes = currentRound.data.slice(1).map(function (dataObj) {
        return dataObj.value || 0;
      });
      this.initUpdateOption();
    },

    //initializing the initial graph
    initInitialGraph: function initInitialGraph() {
      this.goTo();
      this.disablestart = false;

      this.count = 0;
      this.count = this.count + 1;
      var round0 = Object(__WEBPACK_IMPORTED_MODULE_15__config_app_config__["b" /* getInitialRoundObj */])();
      this.updatedOption = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, round0, { hasVotingEnded: false });

      // Set initial vote values
      if (round0 && round0[0] && round0[0].data) {
        this.currentVotes = round0[0].data.map(function (dataObj) {
          return dataObj.value || 0;
        });
      }
      this.graphInitor();
    },

    goTo: function goTo() {
      var element = document.getElementById("wrapper");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center"
        });
      }
    },

    //reseting the graph when the start is clicked
    resetGraph: function resetGraph() {
      // this.disablestart = false;
      this.goTo();

      var initialRound = Object(__WEBPACK_IMPORTED_MODULE_15__config_app_config__["b" /* getInitialRoundObj */])();
      appData = Object(__WEBPACK_IMPORTED_MODULE_15__config_app_config__["a" /* getAppConfig */])();

      // MODIFIED: Get chart config without title property
      var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["g" /* getChartConfig */])({
        stepValue: 1,
        hasVotingEnded: false,
        axisData: this.rowHeader,
        winnerText: this.winnerText
      });

      var chartOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: initialRound
      });
      // this.updatedOption = chartOptions;
      this.chart = this.$refs.myEchart;
      this.count = 0;
      this.count = this.count + 1;
      this.chart.setOption({}, true);
      this.chart.setOption(chartOptions, true);
    },

    // initializing the graph with updated option
    updateGraph: function updateGraph(updatedOption) {
      var currentOption = [];
      if (this.count == 1) {
        currentOption = updatedOption.slice(0, this.count);
      } else if (this.count == 6 && this.final == true) {
        currentOption = updatedOption.slice(6, 7);
      } else {
        currentOption = updatedOption.slice(1, this.count);
      }

      var updatedBallotRounds = Object(__WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["e" /* formatRounds */])(currentOption, this.count, this.label);

      if (updatedBallotRounds.length > 0) {
        updatedBallotRounds.forEach(function (round) {
          if (round.label) {
            round.label.show = false;
          }
        });
      }

      this.updatedOption = updatedBallotRounds;
      var stepValue = this.count;
      var hasVotingEnded = false;
      if (this.updatedOption[0] != null) {
        hasVotingEnded = this.updatedOption[0].hasVotingEnded;
        if (this.count == 6 && this.final == true) {
          hasVotingEnded = true;
        }
      }

      var axisData = this.rowHeader;
      var winnerText = this.winnerText;

      // MODIFIED: Get chart config without title property
      var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["g" /* getChartConfig */])({
        stepValue: stepValue,
        hasVotingEnded: hasVotingEnded,
        axisData: axisData,
        winnerText: winnerText
      });

      var updatedOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: updatedBallotRounds
      });

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).length > 0) {
        this.chart = this.$refs.myEchart;

        this.chart.setOption(updatedOptions, {
          notMerge: true,
          lazyUpdate: false,
          silent: false
        });
      }
    },

    //initializing the graph with default value
    graphInitor: function graphInitor() {
      var stepValue = this.count;
      var ballotRounds = this.updatedOption;
      var hasVotingEnded = this.updatedOption.hasVotingEnded;

      // MODIFIED: Get chart config without title property
      var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["g" /* getChartConfig */])({
        stepValue: stepValue,
        hasVotingEnded: hasVotingEnded,
        axisData: this.rowHeader,
        winnerText: this.winnerText
      });

      var chartOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: ballotRounds
      });

      this.chart = this.$refs.myEchart;
      this.chart.setOption(chartOptions, true);
    }

  },

  created: function created() {
    var _this3 = this;

    var testData = void 0;
    this.styleProps = __WEBPACK_IMPORTED_MODULE_13__config_chart_config_v2__["i" /* isSmallScreen */] ? { width: "100%", height: "571px" } : { width: "100%", height: "570px" };
    var currentInstance = this;
    var cultureDefault = document.documentElement.lang;
    var culture = document.getElementById("ApplicationCulture").val;
    var pageId = window.rcvV2PageId;
    var url = "";
    var location = window.location;
    if (culture != null) {
      url = location.origin + "/v2practicercv/getRcV2?pageId=" + pageId + "&culture=" + culture;
      // url = `http://localhost:63238/v2practicercv/getRcV2?pageId=4949&culture=en-Us`;
      // url = `https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getRcV2?pageId=2312&culture=en-Us`;
    } else {
      url = location.origin + "/v2practicercv/getRcV2?pageId=" + pageId + "&culture=" + cultureDefault;
      // url = `http://localhost:63238/v2practicercv/getRcV2?pageId=4949&culture=en-Us`;
      //url = `https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getRcV2?pageId=2312&culture=en-Us`;
    }

    var axios = __webpack_require__(151);
    currentInstance.axios.get(url, {}).then(function (response) {
      currentInstance.loader = true;
      if (response.status == 200) {
        var data = response.data.responseObject;
        // testData = response.data.responseObject;

        _this3.heading = data.heading;
        _this3.description = data.description;
        _this3.ballotsCountedImage = data.ballotsCountedImage;
        _this3.startPageAltText = data.altText;
        _this3.start = data.start;
        _this3.stepHeadingText = data.stepHeadingText;
        _this3.instructionSet = data.steps;
        _this3.exitButtonLink = data.exitButtonLink;
        _this3.roundValue = data.steps.map(function (step) {
          return step.stepTitle;
        });
        _this3.buttonLabel = data.steps.map(function (step) {
          return step.buttonLabel;
        });

        // this.rowHeader = data.rowHeaders.map(item => ({
        //   id: item.id,
        //   candidateName: item.candidateName,
        //   description: item.description,
        //   imageUrl: item.imageUrl,
        //   color: item.color
        // }));
        _this3.rowHeader = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.rowHeaders.map(function (item) {
          return {
            id: item.id,
            candidateName: item.candidateName ? item.candidateName : "",
            description: item.description,
            imageUrl: item.imageUrl,
            color: item.color,
            altText: item.altText

          };
        })), [{ id: null, candidateName: null, description: null, imageUrl: null, color: null }]);
        _this3.winnerText = (data.resultText || "").replace(/\\n/g, "\n");
        _this3.label = data.voteText;
        var labelColor = ["#fdf751", "#221649", "#4ba3b7", "#ed7aca", "#eb5534", "#367d54"];
        _this3.iconColor = labelColor;
        _this3.iconName = data.rowHeaders;

        setTimeout(function () {
          currentInstance.initUpdateOption();
          currentInstance.loader = false;
        }, 1000);
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  mounted: function mounted() {
    if (this.showHowVotesAreCounted) {
      this.initInitialGraph();
    }
  },
  unmounted: function unmounted() {
    if (ballotWinnerTimer !== undefined) {
      clearTimeout(ballotWinnerTimer);
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_assets_button_next_svg__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_assets_button_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__public_assets_button_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public_assets_button_start_svg__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public_assets_button_start_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__public_assets_button_start_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__public_assets_button_previous_svg__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__public_assets_button_previous_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__public_assets_button_previous_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_assets_button_startover_svg__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_assets_button_startover_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__public_assets_button_startover_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InstructionComponent",

  data: function data() {
    return {};
  },

  watch: {
    instruction: function instruction(newinstruction, oldinstruction) {
      this.setFocus();
    }
  },

  props: ["instruction", "disable", "instructioncontent"],

  computed: {
    cssStepValue: function cssStepValue() {
      var cssStepValue = "";
      if (this.instruction == 1) {
        cssStepValue = "stepOne";
      } else if (this.instruction === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    startButton: function startButton() {
      return __WEBPACK_IMPORTED_MODULE_1__public_assets_button_start_svg___default.a;
    },
    nextButton: function nextButton() {
      return __WEBPACK_IMPORTED_MODULE_0__public_assets_button_next_svg___default.a;
    },
    previousButton: function previousButton() {
      return __WEBPACK_IMPORTED_MODULE_2__public_assets_button_previous_svg___default.a;
    },
    startOverButton: function startOverButton() {
      return __WEBPACK_IMPORTED_MODULE_3__public_assets_button_startover_svg___default.a;
    }
  },

  methods: {
    setFocus: function setFocus() {

      this.$refs.roundtitle.focus();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterComponent",

  props: {
    instruction: {
      required: true
    },
    disable: Boolean,
    showBackButton: Boolean,
    start: String,
    currentState: String,
    exitButtonLink: {
      type: String,
      required: false,
      default: '#'
    },
    buttonLabels: {
      required: true
    }
  },

  computed: {
    cssStepValue: function cssStepValue() {
      var cssStepValue = "";
      var instructionValue = parseInt(this.instruction);

      if (instructionValue === 1) {
        cssStepValue = "stepOne";
      } else if (instructionValue === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },


    // Dynamically fetch the button label for the current instruction
    nextRoundText: function nextRoundText() {
      var instructionValue = parseInt(this.instruction);

      // Ensure buttonLabels exists and has the correct index
      if (this.buttonLabels && this.buttonLabels[instructionValue - 1]) {
        return this.buttonLabels[instructionValue - 1];
      }

      // Fallback label if no match is found
      return "Next";
    }
  },

  methods: {
    onStartClick: function onStartClick(event) {
      // this.$emit('start-clicked');
      this.preventScrollAndEmit('start-clicked', event);
      // this.focusBarChart();
    },
    onprevious: function onprevious(event) {
      // this.$emit("onprevious");
      // this.focusBarChart();
      this.preventScrollAndEmit('onprevious', event);
    },
    onnext: function onnext(event) {
      var _this = this;

      if (window.innerWidth < 768 && parseInt(this.instruction) === 5) {
        this.preventScrollAndEmit('onnext', event);
        // Add a small delay to ensure the DOM has updated
        setTimeout(function () {
          _this.$nextTick(function () {
            var instructionsElement = document.querySelector('.instructions');
            var headingElement = document.querySelector('.rcv__header');

            if (instructionsElement && headingElement) {
              // Get the element positions
              var instructionsRect = instructionsElement.getBoundingClientRect();
              var windowHeight = window.innerHeight;

              // Check if instructions are visible in viewport (scrolled down)
              if (instructionsRect.top <= windowHeight && instructionsRect.bottom >= 0) {
                headingElement.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        }, 100);
      } else {
        this.preventScrollAndEmit('onnext', event);
      }
    },
    onreset: function onreset(event) {
      // this.$emit("onreset");
      // this.focusBarChart();
      this.preventScrollAndEmit('onreset', event);
    },
    backToStartPage: function backToStartPage(event) {
      // this.$emit("backToStartPageClicked");
      // this.focusBarChart();
      this.preventScrollAndEmit('backToStartPageClicked', event);
    },
    onExitClick: function onExitClick(event) {
      // Check if exitButtonLink exists and redirect to it
      // if (this.exitButtonLink && this.exitButtonLink.trim() !== '') {
      //   window.location.href = this.exitButtonLink;
      // } 
      // this.focusBarChart();
      event.preventDefault();
      if (this.exitButtonLink && this.exitButtonLink.trim() !== '') {
        window.location.href = this.exitButtonLink;
      }
    },
    preventScrollAndEmit: function preventScrollAndEmit(eventName, event) {
      // Prevent default behavior
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      // Store current scroll position
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Temporarily prevent scrolling
      document.body.style.overflow = 'hidden';

      // Emit the event
      this.$emit(eventName);

      // Reset scroll position and re-enable scrolling after a short delay
      this.$nextTick(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, currentScroll);
          // Re-enable scrolling after ensuring scroll position is maintained
          setTimeout(function () {
            document.body.style.overflow = '';
          }, 100);
        });
      });
    },
    preventScroll: function preventScroll(e) {
      // Only prevent scroll if it's a button interaction
      if (e.target.closest('.rcv__btn')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  mounted: function mounted() {
    // We don't need the touchmove handler anymore since we're only preventing scroll on button clicks
  },
  beforeDestroy: function beforeDestroy() {
    // No need to remove handlers
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RcvV2StartPage',
  props: {
    heading: String,
    description: String,
    ballotsCountedImage: String,
    altText: String
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IconComponent",

  data: function data() {
    return {
      burstclass: null,
      orderMapping: [0, 1, 2, 3, 4, 5],
      // Map colors to their corresponding classes
      colorClassMap: {
        "#367d54": "rcv__candidate-color-6", // green
        "#fdf751": "rcv__candidate-color-1", // yellow
        "#221649": "rcv__candidate-color-2", // dark blue
        "#4ba3b7": "rcv__candidate-color-3", // light blue
        "#ed7aca": "rcv__candidate-color-4", // pink
        "#eb5534": "rcv__candidate-color-5" // orange
      },
      accumulatedVotes: [0, 0, 0, 0, 0, 0],
      previousVotes: [0, 0, 0, 0, 0, 0]
    };
  },


  props: ["step", "colorvalue", "candidates", "votes", "isNext", "voterText"],

  watch: {
    votes: {
      handler: function handler(newVotes) {
        // Update accumulated votes when votes prop changes
        if (this.isNext) {
          if (newVotes && newVotes.length) {
            this.accumulatedVotes = this.accumulatedVotes.map(function (prev, index) {
              return prev + (newVotes[index] || 0);
            });
          }
        } else {
          if (this.step === 1) {
            this.accumulatedVotes = [0, 0, 0, 0, 0, 0];
          } else if (this.step === 2) {
            this.accumulatedVotes = [25, 15, 10, 5, 30, 15];
          } else if (this.step === 3) {
            this.accumulatedVotes = [27, 16, 10, 5, 32, 15];
          } else if (this.step === 4) {
            this.accumulatedVotes = [32, 17, 10, 5, 32, 15];
          } else if (this.step === 5) {
            this.accumulatedVotes = [46, 17, 10, 5, 37, 16];
          }
        }
      }
    },
    step: {
      handler: function handler(step, oldStep) {}
    }
  },
  methods: {
    isDisabled: function isDisabled(index) {
      var originalIndex = this.getOriginalIndex(index);
      switch (this.step) {
        case 3:
          return originalIndex === 3; // disable 4th item
        case 4:
          return originalIndex === 2 || originalIndex === 3; // disable 3rd and 4th items
        case 5:
          return originalIndex === 2 || originalIndex === 3 || originalIndex === 5; // disable 3rd, 4th, 6th items
        case 6:
          return originalIndex === 1 || originalIndex === 2 || originalIndex === 3 || originalIndex === 5; // disable 2nd, 3rd, 4th, 6th items
        default:
          return false;
      }
    },

    // Convert the display index to the original data index
    getOriginalIndex: function getOriginalIndex(displayIndex) {
      return this.orderMapping[displayIndex];
    },


    // Get the static color class based on display position
    getStaticColorClass: function getStaticColorClass(displayIndex) {
      var originalIndex = this.getOriginalIndex(displayIndex);
      var candidate = this.candidates[originalIndex];
      if (candidate && candidate.color) {
        return this.colorClassMap[candidate.color] || "rcv__candidate-color-6"; // default to color-6 if no match
      }
      return "rcv__candidate-color-6"; // default color class
    },


    // Get accumulated votes for a candidate
    getAccumulatedVotes: function getAccumulatedVotes(index) {
      return this.accumulatedVotes[index];
    }
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isSmallScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMediumScreen; });
/* unused harmony export isLargeScreen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return barLabelProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return stepFivePurpleColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stepFiveOrangeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fiftyPercentLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return genericProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emptyDataObj; });
/* harmony export (immutable) */ __webpack_exports__["e"] = formatRounds;
/* harmony export (immutable) */ __webpack_exports__["g"] = getChartConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_assets_person_black_svg__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_assets_person_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__public_assets_person_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_assets_person_blue_svg__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_assets_person_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_assets_person_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_assets_person_green_svg__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_assets_person_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_assets_person_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_assets_person_orange_svg__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_assets_person_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_assets_person_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_assets_person_pink_svg__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_assets_person_pink_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_assets_person_pink_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_assets_person_yellow_svg__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_assets_person_yellow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_assets_person_yellow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_assets_person_purple_burst_svg__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_assets_person_purple_burst_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_assets_person_purple_burst_svg__);











var type = "bar";
var stack = true;
var colorTransparent = "rgba(255, 255, 255, 0)";
// const splitLineColor = "#cac6d4";

var fiftyPercentLineColor = "#333";
var axisLabelColor = "#000";
var fontFamily = 'Whyte, sans-serif';

var isSmallScreen = window.innerWidth < 600;
var isMediumScreen = window.innerWidth >= 426 && window.innerWidth < 769;
var isLargeScreen = window.innerWidth >= 769;
var barWidth = isSmallScreen ? 19 : 24;
var splitLineColor = isSmallScreen ? "transparent" : "#cac6d4";
var barLabelProps = {
  label: {
    fontSize: isSmallScreen || isMediumScreen ? 13 : 18

  }
};

var iconPaths = ["", __WEBPACK_IMPORTED_MODULE_3__public_assets_person_black_svg___default.a, __WEBPACK_IMPORTED_MODULE_4__public_assets_person_blue_svg___default.a, __WEBPACK_IMPORTED_MODULE_5__public_assets_person_green_svg___default.a, __WEBPACK_IMPORTED_MODULE_8__public_assets_person_yellow_svg___default.a, __WEBPACK_IMPORTED_MODULE_6__public_assets_person_orange_svg___default.a, __WEBPACK_IMPORTED_MODULE_7__public_assets_person_pink_svg___default.a, __WEBPACK_IMPORTED_MODULE_9__public_assets_person_purple_burst_svg___default.a];

// export const customColors = [
//   "rgba(255, 255, 255, 0)",
//   "#221649", // Purple
//   "#4BA3B7", // Blue
//   "#367D54", // Green
//   "#FADE4B", // Yellow
//   "#EB5534", // Orange
//   "#ED7ACA" // Pink
// ];
var customColors = ["rgba(255, 255, 255, 0)", "#367D54", // Green
"#e8c81d", // Yellow
"#221649", // Purple
"#4BA3B7", // Blue
"#ED7ACA", // Pink
"#EB5534" // Orange
];

var stepFivePurpleColors = [customColors[1], customColors[1], customColors[4], customColors[3], customColors[6], customColors[2]];

var stepFiveOrangeColors = [customColors[5], customColors[5], customColors[4], customColors[3], customColors[6], customColors[2]];

var fiftyPercentLine = {
  silent: true,
  lineStyle: {
    color: fiftyPercentLineColor,
    type: "dashed",
    width: 3,
    opacity: 0.15
  },
  label: {
    show: false
  },
  symbolSize: 0,
  data: [{
    symbolOffset: [5, 5],
    y: 10,
    xAxis: 50
  }],
  animation: false
};

var genericProps = {
  type: type,
  barWidth: barWidth,
  stack: stack,
  silent: true,
  animation: true,
  animationEasing: "circularOut",
  animationEasingUpdate: "circularOut",
  animationDuration: 1000,
  animationDelay: function animationDelay(idx) {
    return idx * 75;
  },
  animationDelayUpdate: function animationDelayUpdate(idx) {
    return idx * 50;
  },
  itemStyle: {
    borderColor: '#cac6d4',
    borderWidth: 0.5,
    borderType: 'solid'
  }
};

var emptyDataObj = {
  value: null,
  itemStyle: {
    color: colorTransparent
  }
};

var iconStyleNames = ["", "purple", "blue", "green", "yellow", "orange", "pink", "purpleBurst"];

var iconFadeStyleNames = ["", "purpleFade", "blueFade", "greenFade", "yellowFade", "orangeFade", "pinkFade", "purpleBurstFade"];

var iconSpaces = {
  sm: ["", "                  ", "                  ", "                  ", "                  ", "                  ", "                  ", "          "],
  md: ["", "    ", "    ", "    ", "    ", "   ", "   ", "  "]
};
var iconTextSpaces = {
  sm: ["", "          ", "              ", "           ", "          ", "        ", "              ", "        "],
  md: ["", "     ", "         ", "      ", "     ", "    ", "          ", " "]
};

function getIconStyles(hasVotingEnded) {
  var iconStyleProps = {};
  var iconFadeStyleProps = {};
  var textFade = {
    opacity: hasVotingEnded ? 0.05 : 0.2,
    fontWeight: 700,
    fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
    fontFamily: fontFamily
  };

  iconPaths.forEach(function (iconPath, i) {
    var burstIconHeightLarge = 50;
    var burstIconHeightSmall = 42;
    var iconHeightLarge = 22;
    var iconHeightSmall = 17;
    var iconHeight = void 0;
    var iconBurstHeight = void 0;

    if (isSmallScreen || isMediumScreen) {
      iconHeight = iconHeightSmall;
      iconBurstHeight = burstIconHeightSmall;
    } else {
      iconHeight = iconHeightLarge;
      iconBurstHeight = burstIconHeightLarge;
    }

    var updatedIconStyleProps = {
      backgroundColor: {
        image: iconPath
      },
      height: i === 7 ? iconBurstHeight : iconHeight,
      align: "right"
    };
    iconStyleProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconStyleProps, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, iconStyleNames[i], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, updatedIconStyleProps)));
    iconFadeStyleProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconFadeStyleProps, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, iconFadeStyleNames[i], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, updatedIconStyleProps, textFade)));
  });
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconStyleProps, iconFadeStyleProps, { textFade: textFade });
}

function formatRounds(ballotRounds, stepValue, label) {
  // Only apply this logic if screen width is below 600px
  if (window.innerWidth >= 100) {
    return ballotRounds;
  }

  var labelPosition = "bottom";
  var labelDistance = 0;
  var isLabelShown = false;
  var labelLayout = {
    hideOverlap: true,
    x: 0,
    dy: 0
  };
  var brLen = ballotRounds.length - 1;

  return ballotRounds.map(function (round, roundIndex) {
    var getSum = function getSum(series) {
      return function (param) {
        var sum = 0;
        series.forEach(function (seriesDatum) {
          sum += seriesDatum.data[param.dataIndex].value;
        });
        return param.dataIndex === 0 ? "" : sum + " " + label;
      };
    };

    if (isMediumScreen || isLargeScreen) {
      labelLayout = {
        hideOverlap: true
      };
    }

    if (stepValue === 2 || roundIndex === brLen) {
      isLabelShown = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(round, {
      label: {
        fontFamily: fontFamily,
        show: isLabelShown,
        formatter: stepValue === 1 ? "" : getSum(ballotRounds),
        position: labelPosition,
        distance: labelDistance,
        align: "left",
        offset: [50, 10]
      },
      labelLayout: labelLayout
    });
  });
}

function getChartConfig(_ref) {
  var stepValue = _ref.stepValue,
      hasVotingEnded = _ref.hasVotingEnded,
      axisData = _ref.axisData,
      winnerText = _ref.winnerText;


  var chartConfig = {

    grid: {
      left: "2%",
      right: "0%",
      bottom: "0%",
      top: isSmallScreen ? "-12.6%" : "-12.8%",
      height: isSmallScreen ? "100%" : "100%",
      width: isSmallScreen ? "100%" : "100%",
      containLabel: true
    },

    xAxis: {
      type: "value",
      inverse: false,
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily: fontFamily,
        color: "black",
        fontSize: isSmallScreen || isMediumScreen ? 14 : 18,
        padding: isSmallScreen || isMediumScreen ? [10, 0, 0, 10] : [0, 0, 0, 0],
        formatter: function formatter(value) {

          return [0, 25, 50].includes(value) ? value + "%" : "";
        }
      },
      interval: 25,
      min: 0,
      max: 60
    },

    yAxis: {
      type: "category",
      offset: -10,
      splitLine: {
        show: true,
        lineStyle: {
          width: 3,
          color: splitLineColor
        }
      },
      inverse: true,
      data: axisData,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily: fontFamily,
        color: axisLabelColor,
        fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
        fontWeight: "bolder",
        formatter: function formatter(axisLabel, axisIndex) {},

        verticalAlign: "top",
        textAlign: "left",
        rich: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, getIconStyles(hasVotingEnded))
      }
    }
  };

  return chartConfig;
}

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
// console.log('window.rcvV2PageId:', window.rcvV2PageId);
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  provide: {
    rcvV2PageId: window.rcvV2PageId
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RcvV2_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e38c80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RcvV2_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07e38c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RcvV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e38c80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RcvV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionComponentV2_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab43537e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionComponentV2_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionComponentV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab43537e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionComponentV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgZmlsbD0iI0VCNTUzNCIvPg0KPHBhdGggZD0iTTMyLjA2MDcgMjMuMDYwN0MzMi42NDY0IDIyLjQ3NDkgMzIuNjQ2NCAyMS41MjUxIDMyLjA2MDcgMjAuOTM5M0wyMi41MTQ3IDExLjM5MzRDMjEuOTI4OSAxMC44MDc2IDIwLjk3OTIgMTAuODA3NiAyMC4zOTM0IDExLjM5MzRDMTkuODA3NiAxMS45NzkyIDE5LjgwNzYgMTIuOTI4OSAyMC4zOTM0IDEzLjUxNDdMMjguODc4NyAyMkwyMC4zOTM0IDMwLjQ4NTNDMTkuODA3NiAzMS4wNzExIDE5LjgwNzYgMzIuMDIwOCAyMC4zOTM0IDMyLjYwNjZDMjAuOTc5MiAzMy4xOTI0IDIxLjkyODkgMzMuMTkyNCAyMi41MTQ3IDMyLjYwNjZMMzIuMDYwNyAyMy4wNjA3Wk0xMCAyMy41SDMxVjIwLjVIMTBWMjMuNVoiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNDIgMCkiIGZpbGw9IiNFQjU1MzQiLz4NCjxwYXRoIGQ9Ik05LjkzOTM0IDIzLjA2MDdDOS4zNTM1NSAyMi40NzQ5IDkuMzUzNTUgMjEuNTI1MSA5LjkzOTM0IDIwLjkzOTNMMTkuNDg1MyAxMS4zOTM0QzIwLjA3MTEgMTAuODA3NiAyMS4wMjA4IDEwLjgwNzYgMjEuNjA2NiAxMS4zOTM0QzIyLjE5MjQgMTEuOTc5MiAyMi4xOTI0IDEyLjkyODkgMjEuNjA2NiAxMy41MTQ3TDEzLjEyMTMgMjJMMjEuNjA2NiAzMC40ODUzQzIyLjE5MjQgMzEuMDcxMSAyMi4xOTI0IDMyLjAyMDggMjEuNjA2NiAzMi42MDY2QzIxLjAyMDggMzMuMTkyNCAyMC4wNzExIDMzLjE5MjQgMTkuNDg1MyAzMi42MDY2TDkuOTM5MzQgMjMuMDYwN1pNMzIgMjMuNUgxMVYyMC41SDMyVjIzLjVaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"roundtitle",staticClass:"instructions",attrs:{"tabindex":"0"}},[(this.instruction)?_c('div',[(_vm.instructioncontent[this.instruction - 1])?_c('div',[(_vm.instructioncontent[this.instruction - 1].content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.instructioncontent[this.instruction - 1].content)}}):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterButtonComponent_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc0f3cb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterButtonComponent_vue__ = __webpack_require__(540);
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterButtonComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc0f3cb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterButtonComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.cssStepValue},[_c('div',{staticClass:"rcv__footer-row"},[(parseInt(_vm.instruction) === 0)?_c('div',{staticClass:"rcv__footer-right"},[_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Start click"},on:{"click":function($event){return _vm.onStartClick($event)}}},[_c('span',[_vm._v(_vm._s(_vm.start))])])]):_vm._e(),_vm._v(" "),(parseInt(_vm.instruction) == 1)?_c('div',{staticClass:"rcv__footer-left"},[_c('a',{staticClass:"rcv__btn rcv__btn__primary",attrs:{"href":"#","role":"button","aria-label":"Go back to the start page"},on:{"click":function($event){return _vm.backToStartPage($event)}}},[_vm._m(0)])]):_vm._e(),_vm._v(" "),(parseInt(_vm.instruction) > 1 && parseInt(_vm.instruction) <= 6)?_c('div',{staticClass:"rcv__footer-left"},[_c('a',{staticClass:"rcv__btn rcv__btn__primary",attrs:{"href":"#","role":"button","aria-label":"Go back to the previous page"},on:{"click":function($event){return _vm.onprevious($event)}}},[_vm._m(1)])]):_vm._e(),_vm._v(" "),(parseInt(_vm.instruction) === 1)?_c('div',{staticClass:"rcv__footer-right"},[_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Start"},on:{"click":function($event){return _vm.onnext($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextRoundText))])])]):_vm._e(),_vm._v(" "),(parseInt(_vm.instruction) === 6)?_c('div',{staticClass:"rcv__footer-right"},[_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","alt":"exit ballot","role":"button","width":"120px"},on:{"click":function($event){return _vm.onExitClick($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextRoundText))])])]):_vm._e(),_vm._v(" "),(parseInt(_vm.instruction) > 1 && parseInt(_vm.instruction) < 6)?_c('div',{staticClass:"rcv__footer-right"},[_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"next round"},on:{"click":function($event){return _vm.onnext($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextRoundText))])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("<")]),_vm._v(" Back ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("<")]),_vm._v(" Back")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rcv2StartPage_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be0874b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rcv2StartPage_vue__ = __webpack_require__(542);
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rcv2StartPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be0874b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rcv2StartPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[_c('h1',[_vm._v(_vm._s(_vm.heading))])]),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-row"},[_c('div',{staticClass:"rcv__start-screen-left"},[_c('img',{attrs:{"src":_vm.ballotsCountedImage,"alt":_vm.altText,"width":"800","height":"379"}})]),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-right",domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateIconComponentV2_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412eecda_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateIconComponentV2_vue__ = __webpack_require__(544);
var normalizeComponent = __webpack_require__(55)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateIconComponentV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412eecda_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateIconComponentV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-left-panel"},[(_vm.colorvalue)?_c('div',_vm._l((6),function(newIndex){return _c('div',{key:newIndex - 1,staticClass:"left-panel__item red-color"},[_c('div',{class:[
           'rcv__canditate-profile',
           {'disabled-item': _vm.isDisabled(newIndex - 1)}
         ]},[_c('div',{class:['rcv__candidate-avatar', _vm.getStaticColorClass(newIndex - 1)]},[(_vm.candidates[_vm.getOriginalIndex(newIndex - 1)] && _vm.candidates[_vm.getOriginalIndex(newIndex - 1)].imageUrl)?_c('img',{attrs:{"src":_vm.candidates[_vm.getOriginalIndex(newIndex - 1)].imageUrl,"alt":_vm.candidates[_vm.getOriginalIndex(newIndex - 1)].altText,"width":"90","height":"90"}}):_vm._e()])]),_vm._v(" "),(_vm.getOriginalIndex(newIndex - 1) == 0 && _vm.step == 6)?_c('div',{staticClass:"burst-bg"}):_vm._e(),_vm._v(" "),_c('div',{class:[
           'content-text',
           {'disabled-item': _vm.isDisabled(newIndex - 1)}
         ]},[_c('h5',[_vm._v(_vm._s(_vm.candidates[_vm.getOriginalIndex(newIndex - 1)].candidateName))]),_vm._v(" "),_c('div',{staticClass:"vote-value"},[_c('p',[_vm._v(_vm._s(_vm.getAccumulatedVotes(_vm.getOriginalIndex(newIndex - 1)))+" "+_vm._s(_vm.voterText))])])])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pigion.c3adc2b.png";

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiMyMjE0NEEiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiM0QkEzQjciLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiMzNjdENTQiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNFQjU1MzQiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNFRDdBQ0EiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNGQURFNEIiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1NyA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yOC4xNDg0IC0wLjAwMDk5OTQ1MUwzNC43NzE2IDIwLjM4M0g1Ni4yMDQ2TDM4Ljg2NDkgMzIuOTgxTDQ1LjQ4ODEgNTMuMzY1TDI4LjE0ODQgNDAuNzY3TDEwLjgwODggNTMuMzY1TDE3LjQzMTkgMzIuOTgxTDAuMDkyMzAwNCAyMC4zODNIMjEuNTI1M0wyOC4xNDg0IC0wLjAwMDk5OTQ1MVoiIGZpbGw9IiNGREY3NTEiLz4NCjxwYXRoIGQ9Ik0xMS4wMTIgNS40ODcxTDI4LjI0NDMgMTguMjMxNEw0NS42OTAxIDUuNzgwN0wzOC44OTQ1IDI2LjEwNzlMNTYuMTI2OSAzOC44NTIzTDM0LjY5NDcgMzguNjcwOEwyNy44OTkxIDU4Ljk5OEwyMS40NDg4IDM4LjU1ODZMMC4wMTY1OTk3IDM4LjM3NzFMMTcuNDYyMyAyNS45MjY0TDExLjAxMiA1LjQ4NzFaIiBmaWxsPSIjRkRGNzUxIi8+DQo8cGF0aCBkPSJNMjguNjQ4NCAyOUMzMi4xMjAzIDI5IDM0LjkzNDIgMjYuMzE0MSAzNC45MzQyIDIzQzM0LjkzNDIgMTkuNjg1OSAzMi4xMjAzIDE3IDI4LjY0ODQgMTdDMjUuMTc2NiAxNyAyMi4zNjI3IDE5LjY4NTkgMjIuMzYyNyAyM0MyMi4zNjI3IDI2LjMxNDEgMjUuMTc2NiAyOSAyOC42NDg0IDI5Wk0zMy4wNDg0IDMwLjVIMzIuMjI4M0MzMS4xMzgyIDMwLjk3ODEgMjkuOTI1MiAzMS4yNSAyOC42NDg0IDMxLjI1QzI3LjM3MTcgMzEuMjUgMjYuMTYzNiAzMC45NzgxIDI1LjA2ODUgMzAuNUgyNC4yNDg0QzIwLjYwNDcgMzAuNSAxNy42NDg0IDMzLjMyMTkgMTcuNjQ4NCAzNi44VjM4Ljc1QzE3LjY0ODQgMzkuOTkyMiAxOC43MDQyIDQxIDIwLjAwNTYgNDFIMzcuMjkxM0MzOC41OTI2IDQxIDM5LjY0ODQgMzkuOTkyMiAzOS42NDg0IDM4Ljc1VjM2LjhDMzkuNjQ4NCAzMy4zMjE5IDM2LjY5MjIgMzAuNSAzMy4wNDg0IDMwLjVaIiBmaWxsPSIjMjIxNDRBIi8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialRoundObj;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__ = __webpack_require__(254);



function getInitialRoundObj() {
	var initialRound = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r0"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["d" /* fiftyPercentLine */],
		data: [{
			value: 65,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][0],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][1],
				opacity: 1,
				borderWidth: 0

			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][5],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][6],
				opacity: 1
			},
			label: {
				show: false
			}
		}]
	});
	return initialRound;
}

function getAppConfig() {
	var round0 = getInitialRoundObj();
	var appData = [round0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r1"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["d" /* fiftyPercentLine */],
		animationDelay: null,
		animationDelayUpdate: null,
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 25, //25
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][1],
				label: {
					show: true
				}

			}

		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 15, //15
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 10, //10
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5, //5
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 30, //30
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][5]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 15, //15
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r2"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r3"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 3,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r4"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 14,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r5"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 6,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 11,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r6"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["d" /* fiftyPercentLine */],
		hasVotingEnded: true,
		animation: false,
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 52,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 17,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][2]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 10,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][3]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][4]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 48,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][5]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 16,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["b" /* customColors */][6]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config_v2__["a" /* barLabelProps */])]
	})];
	return appData;
}

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showStartPage)?_c('section',{staticClass:"start__screen-module",attrs:{"id":"rcv__content"}},[_c('v-start-page',{attrs:{"heading":_vm.heading,"description":_vm.description,"ballotsCountedImage":_vm.ballotsCountedImage,"altText":_vm.startPageAltText}})],1):_vm._e(),_vm._v(" "),(_vm.showHowVotesAreCounted)?_c('div',{attrs:{"id":"wrapper"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loader),expression:"!loader"}],staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[(_vm.count)?_c('div',[_c('h1',[_vm._v("\n\n            "+_vm._s(("" + (_vm.roundValue[_vm.count - 1])))+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"rcv"},[_c('div',{staticClass:"chart-wrapper",class:{ 'winner-active': _vm.count == 6 && _vm.final === true }},[_c('div',{staticClass:"barchart-icon"},[_c('v-icon',{attrs:{"step":_vm.count,"colorvalue":_vm.iconColor,"candidates":_vm.rowHeader,"votes":_vm.currentVotes,"isNext":_vm.isNext,"voterText":_vm.label}})],1),_vm._v(" "),_c('div',{staticClass:"barChart"},[(_vm.count == 6 && _vm.final == true)?_c('div',{staticClass:"winner-announcement",style:(_vm.winnerDivStyle)},[_c('div',{staticClass:"winner-announcement-child"},[(_vm.winnerImageUrl)?_c('img',{staticClass:"winner-image",attrs:{"src":_vm.winnerImageUrl,"alt":"Winner Image"}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.winnerText))])])]):_vm._e(),_vm._v(" "),_c('v-chart',{ref:"myEchart",staticClass:"chart",style:(_vm.styleProps),attrs:{"autoresize":true,"option":_vm.chartOptions}})],1)]),_vm._v(" "),(_vm.instructionSet)?_c('v-instructions',{ref:"instruction",attrs:{"instruction":this.count,"disable":_vm.disablestart,"instructioncontent":_vm.instructionSet}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}]},[_vm._m(0)])]):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"rcv__footer"},[_c('v-footer-button',{attrs:{"buttonLabels":_vm.buttonLabel,"exitButtonLink":_vm.exitButtonLink,"instruction":this.count,"current-state":_vm.footerButtonState,"disable":_vm.disablestart,"start":_vm.start,"show-back-button":_vm.showBackButton},on:{"onreset":_vm.resetGraph,"onprevious":_vm.onprevious,"onnext":_vm.onnext,"start-clicked":_vm.startClicked,"backToStartPageClicked":_vm.backToStartPage}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"dot-loader"}),_vm._v(" "),_c('div',{staticClass:"dot-loader dot-loader--2"}),_vm._v(" "),_c('div',{staticClass:"dot-loader dot-loader--3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{},[_c('RcvV2')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(159);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'App',
    component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }]
}));

/***/ })

},[278]);


// WEBPACK FOOTER //
// static/js/app.0173070e9bb74d7eb447.js